import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { Col, Row } from 'react-bootstrap';
import 'react-range-slider-input/dist/style.css';
import { GetErrorMessageByFieldNameType } from '../../../../../hooks/useErrors';
import { KindOfVtSpTransType, TransfersBehaviorType } from '../../types';
import RoutingRulesCard from './components/RoutingRulesCard';
import RoutingValuesCard from './components/RoutingValuesCard';

export interface RoutingRulesCardI {
  copyGoingToReturn: boolean;
  setCopyGoingToReturn: Dispatch<SetStateAction<boolean>>;
  hasAffreightment: boolean;
  setHasAffreightment: Dispatch<SetStateAction<boolean>>;
  hasKmLimit: boolean;
  setHasKmLimit: Dispatch<SetStateAction<boolean>>;
  selectedKmLimit: number[];
  setSelectedKmLimit: Dispatch<SetStateAction<number[]>>;
  selectedWalkDistance: number[];
  setSelectedWalkDistance: Dispatch<SetStateAction<number[]>>;
  transfersBehavior: TransfersBehaviorType;
  setTransfersBehavior: Dispatch<SetStateAction<TransfersBehaviorType>>;
  handleKmLimitSelection: (range: number[]) => void;
  handleWalkDistanceSelection: (range: number[]) => void;
}

export interface RoutingValuesCardI {
  compareWithDesiredVtValue: boolean;
  desiredVtValue: string;
  chooseDefaultValueForRoutings: boolean;
  defaultValueForRoutings: string;
  kindOfVtSpTrans: KindOfVtSpTransType;
  setKindOfVtSpTrans: Dispatch<SetStateAction<KindOfVtSpTransType>>;
  handleCompareWithDesiredVtValueChange: (willCompare: boolean) => void;
  handleDesiredVtValueChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleChooseDefaultValueForRoutingsChange: (willChoose: boolean) => void;
  handleDefaultValueForRoutingsChange: (event: ChangeEvent<HTMLInputElement>) => void;
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  kindOfVtAesa: string;
  setKindOfVtAesa: Dispatch<SetStateAction<string>>;
  aboveDesiredValueReturnsBiasTag: boolean;
  setAboveDesiredValueReturnsBiasTag: Dispatch<SetStateAction<boolean>>;
  usaRodoviarioValZero: boolean;
  setUsaRodoviarioValZero: Dispatch<SetStateAction<boolean>>;
  kmRodoviarioValZero: number | string;
  setKmRodoviarioValZero: Dispatch<SetStateAction<number | string>>;
  utilizaTetoValorPadraoEmp: boolean;
  setUtilizaTetoValorPadraoEmp: Dispatch<SetStateAction<boolean>>;
}

interface RoutingProcessSettingsTabI extends RoutingRulesCardI, RoutingValuesCardI {}

export default function RoutingProcessSettingsTab({
  copyGoingToReturn,
  setCopyGoingToReturn,
  hasAffreightment,
  setHasAffreightment,
  hasKmLimit,
  setHasKmLimit,
  selectedKmLimit,
  setSelectedKmLimit,
  selectedWalkDistance,
  setSelectedWalkDistance,
  transfersBehavior,
  setTransfersBehavior,
  compareWithDesiredVtValue,
  desiredVtValue,
  chooseDefaultValueForRoutings,
  defaultValueForRoutings,
  kindOfVtSpTrans,
  setKindOfVtSpTrans,
  handleKmLimitSelection,
  handleWalkDistanceSelection,
  handleCompareWithDesiredVtValueChange,
  handleDesiredVtValueChange,
  handleChooseDefaultValueForRoutingsChange,
  handleDefaultValueForRoutingsChange,
  getErrorMessageByFieldName,
  kindOfVtAesa,
  setKindOfVtAesa,
  aboveDesiredValueReturnsBiasTag,
  setAboveDesiredValueReturnsBiasTag,
  usaRodoviarioValZero,
  setUsaRodoviarioValZero,
  kmRodoviarioValZero,
  setKmRodoviarioValZero,
  utilizaTetoValorPadraoEmp,
  setUtilizaTetoValorPadraoEmp,
}: RoutingProcessSettingsTabI) {
  return (
    <Row xs={1} md={1} lg={1}>
      <Col>
        <RoutingRulesCard
          copyGoingToReturn={copyGoingToReturn}
          setCopyGoingToReturn={setCopyGoingToReturn}
          hasAffreightment={hasAffreightment}
          setHasAffreightment={setHasAffreightment}
          hasKmLimit={hasKmLimit}
          setHasKmLimit={setHasKmLimit}
          selectedKmLimit={selectedKmLimit}
          setSelectedKmLimit={setSelectedKmLimit}
          selectedWalkDistance={selectedWalkDistance}
          setSelectedWalkDistance={setSelectedWalkDistance}
          transfersBehavior={transfersBehavior}
          setTransfersBehavior={setTransfersBehavior}
          handleKmLimitSelection={handleKmLimitSelection}
          handleWalkDistanceSelection={handleWalkDistanceSelection}
        />
      </Col>
      <Col>
        <RoutingValuesCard
          compareWithDesiredVtValue={compareWithDesiredVtValue}
          desiredVtValue={desiredVtValue}
          chooseDefaultValueForRoutings={chooseDefaultValueForRoutings}
          defaultValueForRoutings={defaultValueForRoutings}
          kindOfVtSpTrans={kindOfVtSpTrans}
          setKindOfVtSpTrans={setKindOfVtSpTrans}
          handleCompareWithDesiredVtValueChange={handleCompareWithDesiredVtValueChange}
          handleDesiredVtValueChange={handleDesiredVtValueChange}
          handleChooseDefaultValueForRoutingsChange={handleChooseDefaultValueForRoutingsChange}
          handleDefaultValueForRoutingsChange={handleDefaultValueForRoutingsChange}
          getErrorMessageByFieldName={getErrorMessageByFieldName}
          kindOfVtAesa={kindOfVtAesa}
          setKindOfVtAesa={setKindOfVtAesa}
          aboveDesiredValueReturnsBiasTag={aboveDesiredValueReturnsBiasTag}
          setAboveDesiredValueReturnsBiasTag={setAboveDesiredValueReturnsBiasTag}
          usaRodoviarioValZero={usaRodoviarioValZero}
          setUsaRodoviarioValZero={setUsaRodoviarioValZero}
          kmRodoviarioValZero={kmRodoviarioValZero}
          setKmRodoviarioValZero={setKmRodoviarioValZero}
          utilizaTetoValorPadraoEmp={utilizaTetoValorPadraoEmp}
          setUtilizaTetoValorPadraoEmp={setUtilizaTetoValorPadraoEmp}
        />
      </Col>
    </Row>
  );
}
